/**
 *    SPDX-License-Identifier: Apache-2.0
 */

const namespaces = 'tables';

const BLOCK_LIST = `${namespaces}/BLOCK_LIST`;
const BLOCK_LIST_SEARCH = `${namespaces}/BLOCK_LIST_SEARCH`;
const BLOCK_LIST_SEARCH_PARAMS = `${namespaces}/BLOCK_LIST_SEARCH_PARAMS`;
const CHAINCODE_LIST = `${namespaces}/CHAINCODE_LIST`;
const CHANNELS = `${namespaces}/CHANNELS`;
const PEER_LIST = `${namespaces}/PEER_LIST`;
const TRANSACTION = `${namespaces}/TRANSACTION`;
const TRANSACTION_LIST = `${namespaces}/TRANSACTION_LIST`;
const TRANSACTION_LIST_SEARCH = `${namespaces}/TRANSACTION_LIST_SEARCH`;
const TRANSACTION_LIST_SEARCH_PARAMS = `${namespaces}/TRANSACTION_LIST_SEARCH_PARAMS`;
const ORGS = `${namespaces}/ORGS`;

export default {
  BLOCK_LIST,
  BLOCK_LIST_SEARCH,
  BLOCK_LIST_SEARCH_PARAMS,
  CHAINCODE_LIST,
  CHANNELS,
  PEER_LIST,
  TRANSACTION,
  TRANSACTION_LIST,
  TRANSACTION_LIST_SEARCH,
  TRANSACTION_LIST_SEARCH_PARAMS,
  ORGS,
};
